import type { MessageSchema } from "./zh";

const messages: MessageSchema = {
  common: {
    appName: "Jzbro Cloud",
    appNameGlobal: "Starparks",
    confirm: "ঠিক আছে",
    cancel: "বাতিল",
    loginRegister: "লগইন / সাইন আপ",
    userAgreement: "ব্যবহারের শর্তাবলী",
    privacyPolicy: "প্রাইভেসি পলিসি",
    notBound: "সেট করা হয়নি",
  },
  tabbar: {
    home: "হোম",
    search: "সার্চ",
    library: "লাইব্রেরি",
    mine: "আমার",
    badgeLogin: "লগইন",
    badgeUpgrade: "আপ",
  },
  login: {
    navTitle: "লগইন",
    welcome: "{brand}-এ স্বাগতম",
    subtitle: "এসএমএস কোড দিয়ে লগইন করুন, বা WeChat / QQ ব্যবহার করুন",
    subtitleGlobal: "গেস্ট হিসেবে এখনই খেলুন, বা Google / Telegram / Facebook দিয়ে লগইন করুন",
    mobileLabel: "ফোন",
    mobilePlaceholder: "ফোন নম্বর",
    codeLabel: "কোড",
    codePlaceholder: "এসএমএস কোড",
    getCode: "কোড নিন",
    resendIn: "{sec}s পরে আবার পাঠান",
    agreement:
      "অনিবন্ধিত নম্বরে স্বয়ংক্রিয়ভাবে অ্যাকাউন্ট তৈরি হবে। চালিয়ে গেলে আপনি {userAgreement} ও {privacyPolicy}-তে সম্মত হচ্ছেন",
    otherMethods: "অন্যভাবে লগইন করুন",
    guest: "অতিথি হিসেবে চালিয়ে যান",
    wechat: "WeChat দিয়ে লগইন",
    qq: "QQ দিয়ে লগইন",
    google: "Google দিয়ে চালিয়ে যান",
    telegram: "Continue with Telegram",
    facebook: "Facebook দিয়ে চালিয়ে যান",
    wechatComingSoon: "WeChat লগইন শীঘ্রই আসছে",
    qqComingSoon: "QQ লগইন শীঘ্রই আসছে",
    googleComingSoon: "Google লগইন শীঘ্রই আসছে",
    googleFailed: "Google লগইন ব্যর্থ, আবার চেষ্টা করুন",
    telegramFailed: "Telegram login failed, please try again",
    facebookComingSoon: "Facebook লগইন শীঘ্রই আসছে",
    mobileInvalid: "সঠিক ফোন নম্বর লিখুন",
    codeInvalid: "কোডটি লিখুন",
    codeSent: "কোড পাঠানো হয়েছে",
  },
  loginPrompt: {
    defaultMessage: "আপনার গেম দেখতে লগইন করুন",
  },
  settings: {
    navTitle: "সেটিংস",
    loginPrompt: "অ্যাকাউন্ট সেটিংস ম্যানেজ করতে লগইন করুন",
    nickname: "নিকনেম",
    mobile: "ফোন",
    controller: "কন্ট্রোলার সেটিংস",
    controllerDesc: "মাউস সংবেদনশীলতা / ডান স্টিক / কী অদলবদল",
    about: "সম্পর্কে",
    clearCache: "ক্যাশে পরিষ্কার করুন",
    language: "ভাষা",
    editNickname: "নিকনেম এডিট করুন",
    nicknamePlaceholder: "নতুন নিকনেম",
    nickEmpty: "নিকনেম খালি রাখা যাবে না",
    nickTooLong: "নিকনেম সর্বোচ্চ ১৬ অক্ষর",
    updated: "আপডেট হয়েছে",
    cacheCleared: "পরিষ্কার হয়েছে, আবার লগইন করুন",
    aboutTitle: "{brand} সম্পর্কে",
    aboutVersion: "Web সংস্করণ v{version}",
    aboutBody:
      "ক্লাউড গেমিং—যেকোনো জায়গায় ব্রাউজারেই AAA গেম খেলুন।\nসব গেম কনটেন্টের স্বত্ব সংশ্লিষ্ট প্রকাশকদের।",
  },
  subscription: {
    choosePlan: "একটি প্ল্যান বেছে নিন",
    included: "যা যা পাবেন",
    orderSummary: "অর্ডার সারাংশ",
    total: "মোট",
    continue: "চালিয়ে যান",
    secureNote: "নিরাপদ পেমেন্ট · এককালীন কেনাকাটা",
    navTitle: "আপগ্রেড",
    unlockTitle: "সদস্য সুবিধা আনলক করুন",
    expired: "মেয়াদ শেষ",
    daysLeft: "{days} দিন বাকি",
    validUntil: "{time} পর্যন্ত বৈধ",
    tagline: "কিউ নেই, দীর্ঘ সেশন, উন্নত মান",
    perDay: "প্রায় {price}/দিন",
    recommended: "সেরা ডিল",
    currentLevel: "বর্তমান প্ল্যান",
    footer:
      "এটি এককালীন সদস্যপদ কেনাকাটা। পেমেন্ট নিশ্চিত হলে নির্বাচিত মেয়াদ যোগ হবে এবং স্বয়ংক্রিয়ভাবে নবায়ন হবে না।",
    planVipMonth: "VIP মাসিক",
    planSvipMonth: "SVIP মাসিক",
    perkNoQueue: "কিউ এড়িয়ে যান",
    perkDailyFree: "প্রতিদিন ৬০ মিনিট ফ্রি",
    perkHd: "এইচডি মান",
    perkAllVip: "সব VIP সুবিধা",
    perkUnlimited: "সীমাহীন সময়",
    perk4k: "4K / 60fps",
    perkSupport: "অগ্রাধিকার সাপোর্ট",
    cnPayComingSoon:
      "Web-এ WeChat / Alipay পেমেন্ট শীঘ্রই আসছে — আপাতত অ্যাপ ব্যবহার করুন",
    intlPayComingSoon: "Stripe / PayPal পেমেন্ট শীঘ্রই আসছে",
    payProcessing: "পেমেন্ট সম্পন্ন করুন এবং এই পেজটি খোলা রাখুন…",
    paySuccess: "পেমেন্ট সফল — সদস্যপদ চালু হয়েছে",
    payFailed: "পেমেন্ট ব্যর্থ, আবার চেষ্টা করুন",
    payCancelled: "পেমেন্ট বাতিল হয়েছে",
    telegramExtraTimeUnavailable: "Stars সংস্করণ যোগ হওয়ার পর Telegram-এ খেলার সময় কেনা যাবে।",
    payUnconfirmed:
      "পেমেন্ট এখনও নিশ্চিত হয়নি; পেমেন্ট করে থাকলে শীঘ্রই জমা হবে",
    payPopupBlocked:
      "পেমেন্ট উইন্ডো ব্লক হয়েছে — পপ-আপ চালু করে আবার চেষ্টা করুন",
    loadPlansFailed: "প্ল্যান লোড করা যায়নি, আবার চেষ্টা করুন",
    retry: "আবার চেষ্টা",
  },
  app: {
    backToDesktop: "ডেস্কটপে ফিরুন",
  },
  titles: {
    home: "হোম",
    search: "সার্চ",
    detail: "গেম বিস্তারিত",
    library: "লাইব্রেরি",
    category: "ক্যাটাগরি",
    mine: "আমার",
    myGames: "আমার গেম",
    reviews: "রিভিউ",
    gameVideos: "গেমপ্লে ভিডিও",
    commentReplies: "কমেন্ট",
    saves: "সেভ",
    subscription: "আপগ্রেড",
    signIn: "দৈনিক সাইন-ইন",
    settings: "সেটিংস",
    controlSettings: "কন্ট্রোলার সেটিংস",
    login: "লগইন",
    play: "খেলা হচ্ছে",
  },
  home: {
    searchPlaceholder: "গেম সার্চ করুন",
    sectionDefault: "গেম",
    allGames: "সব গেম",
    more: "আরও",
    empty: "এখনও কিছু নেই",
    latestOnline: "নতুন রিলিজ",
    comingSoon: "শীঘ্রই আসছে",
    subscribe: "জানিয়ে দিন",
    subscribed: "সাবস্ক্রাইব করা হয়েছে",
    score: "রেটিং",
    subscribeSuccess: "রিজার্ভ হয়েছে — রিলিজ হলে জানিয়ে দেব",
  },
  nav: {
    home: "হোম",
    library: "লাইব্রেরি",
    searchPlaceholder: "গেম সার্চ করুন",
    me: "আমি",
    guest: "গেস্ট",
    profile: "প্রোফাইল",
    myGames: "আমার গেম",
    dailyCheckIn: "দৈনিক সাইন-ইন",
    renewMembership: "সদস্যপদ নবায়ন",
    upgradeMembership: "সদস্যপদ আপগ্রেড",
    settings: "সেটিংস",
    switchToMobile: "মোবাইলে স্যুইচ করুন",
    logout: "সাইন আউট",
    logoutConfirm: "আপনি কি সাইন আউট করতে চান?",
    mobileVersion: "মোবাইল",
    login: "লগইন",
  },
  library: {
    all: "সব",
    noMore: "আর নেই",
    loading: "লোড হচ্ছে…",
    noData: "কোনো ডাটা নেই",
    noGames: "কোনো গেম নেই",
    noUpcoming: "আসন্ন কোনো গেম নেই",
    emptyCategory: "এই ক্যাটাগরিতে কোনো গেম নেই",
  },
  mine: {
    notLoggedIn: "লগইন করা হয়নি",
    loginSyncTip: "সদস্যপদ, ফেভারিট ও গেম রেকর্ড সিঙ্ক করতে লগইন করুন",
    loginSyncTipDesktop:
      "প্রোফাইল, সদস্যপদ, সাইন-ইন ও গেম রেকর্ড দেখতে লগইন করুন",
    guest: "গেস্ট",
    daysLeft: "{n} দিন বাকি",
    expired: "মেয়াদ শেষ",
    renewBanner: "আপনার {level} {n} দিনে শেষ হবে — ৩০% ছাড়ে নবায়ন করুন",
    membershipExpiredRenew: "সদস্যপদের মেয়াদ শেষ — এখনই নবায়ন করুন",
    membershipExpired: "সদস্যপদের মেয়াদ শেষ",
    membershipDaysLeft: "সদস্যপদের {n} দিন বাকি",
    gameTime: "খেলার সময়",
    minUnit: "মিনিট",
    dailyCheckIn: "দৈনিক সাইন-ইন",
    upgrade: "আপগ্রেড",
    renew: "নবায়ন",
    upgradeMembership: "সদস্যপদ আপগ্রেড",
    renewMembership: "সদস্যপদ নবায়ন",
    membership: "সদস্যপদ",
    myCollection: "আমার ফেভারিট",
    collectedGames: "সেভ করা গেম",
    recentlyPlayed: "সাম্প্রতিক খেলা",
    gameHistory: "গেম ইতিহাস",
    settings: "সেটিংস",
    switchToDesktop: "ডেস্কটপে স্যুইচ করুন",
    accountAndPrefs: "অ্যাকাউন্ট ও পছন্দ",
    claimGameTime: "ফ্রি সময় নিন",
    bindPhone: "ফোন নম্বর বাইন্ড করুন",
    bindPhoneDesc: "পূর্ণ অ্যাকাউন্টে আপগ্রেড করুন ও সব ডিভাইসে সিঙ্ক করুন",
    bindPhoneDescDesktop: "পূর্ণ অ্যাকাউন্টে আপগ্রেড করুন, সব ডিভাইসে সিঙ্ক করুন",
    resetGuest: "গেস্ট পরিচয় রিসেট করুন",
    resetGuestDesc: "এই গেস্ট অ্যাকাউন্ট মুছে নতুন করে শুরু করুন",
    resetGuestDescDesktop: "নতুন পরিচয়ে নতুন করে শুরু করুন",
    logout: "সাইন আউট",
    myGamesTitle: "আমার গেম",
    collectTab: "ফেভারিট",
    loginViewCollect: "সেভ করা গেম দেখতে লগইন করুন",
    noCollect: "এখনও কোনো সেভ করা গেম নেই",
    loginViewHistory: "গেম ইতিহাস দেখতে লগইন করুন",
    noHistory: "সম্প্রতি কোনো গেম খেলা হয়নি",
    weekMon: "সোম",
    weekTue: "মঙ্গল",
    weekWed: "বুধ",
    weekThu: "বৃহস্পতি",
    weekFri: "শুক্র",
    weekSat: "শনি",
    weekSun: "রবি",
    alreadySignedToday: "আজ সাইন-ইন হয়ে গেছে",
    signSuccessReward: "সাইন-ইন হয়েছে! +{n} মিনিট",
    signSuccess: "সাইন-ইন হয়েছে",
    loginJoinCheckIn: "দৈনিক সাইন-ইনে যোগ দিতে লগইন করুন",
    claimed: "নেওয়া হয়েছে",
    unclaimed: "মিস হয়েছে",
    todayDone: "আজ ✓",
    today: "আজ",
    dayN: "দিন {n}",
    signedToday: "আজ সাইন-ইন হয়েছে",
    signNow: "এখনই সাইন-ইন করুন",
    checkInTip1: "ফ্রি খেলার সময় পেতে প্রতিদিন সাইন-ইন করুন।",
    checkInTip2: "মিস করা দিন মেক-আপ পেজে কয়েন দিয়ে পূরণ করা যায়।",
    loggedOut: "সাইন আউট হয়েছে",
    resetGuestConfirm:
      "এটি বর্তমান গেস্ট অ্যাকাউন্ট মুছে নতুন পরিচয়ে নতুন করে শুরু করবে। কেনা সাবস্ক্রিপশন, ফেভারিট ও ইতিহাস সব হারিয়ে যাবে। চালিয়ে যাবেন?",
    resetGuestConfirmBtn: "রিসেট",
    resetting: "রিসেট হচ্ছে…",
    resetDone: "রিসেট সম্পন্ন — আবার লগইন করুন",
  },
  reviews: {
    recommendRate: "সুপারিশ",
    tooFew: "রিভিউ এখনও কম",
    count: "{n}টি রিভিউ",
    playFirst: "রিভিউ দিতে আগে গেমটি খেলুন",
    rateThis: "খেলেছেন? একটি রিভিউ দিন",
    mine: "আমার",
    edit: "সম্পাদনা",
    delete: "মুছুন",
    report: "রিপোর্ট",
    played: "{d} খেলেছেন",
    contentEmpty: "রিভিউ খালি রাখা যাবে না",
    editReview: "রিভিউ সম্পাদনা",
    editDone: "আপডেট হয়েছে",
    published: "রিভিউ পোস্ট হয়েছে",
    deleteTitle: "রিভিউ মুছবেন?",
    deleteConfirm: "এটি ফেরানো যাবে না। এই রিভিউ মুছবেন?",
    deleted: "মুছে ফেলা হয়েছে",
    reportTitle: "রিপোর্ট",
    reportConfirm: "এই কনটেন্ট রিপোর্ট করবেন? আমাদের টিম পর্যালোচনা করবে।",
    reported: "রিপোর্ট করা হয়েছে",
    deleteReplyTitle: "উত্তর মুছবেন?",
    deleteReplyConfirm: "এই উত্তর মুছবেন?",
    replyTo: "উত্তর দিয়েছেন",
    viewAllReplies: "সব {n}টি উত্তর দেখুন",
    loadMore: "আরও দেখুন",
    allReplies: "সব উত্তর ({n})",
    commentDeleted: "এই রিভিউ মুছে ফেলা হয়েছে",
    commentShielded: "এই রিভিউ লুকানো হয়েছে",
    replyDeleted: "এই উত্তর মুছে ফেলা হয়েছে",
    replyShielded: "এই উত্তর লুকানো হয়েছে",
  },
  detail: {
    svipRequiredMsg: "এই গেমটি খেলতে SVIP প্রয়োজন",
    timeInsufficientMsg: "গেম সময় অপর্যাপ্ত, অনুগ্রহ করে আগে গেম সময় কিনুন।",
    goBuy: "এখনই কিনুন",
    thinkAgain: "আরও ভাবুন",
    navTitle: "গেম বিস্তারিত",
    back: "ফিরুন",
    svipOnly: "শুধু SVIP",
    vipOnly: "শুধু VIP",
    freeMinutes: "{n} মিনিট ফ্রি",
    saveManage: "সেভ",
    saveManageDesc: "পুরোনো সেভ দেখুন / ফিরিয়ে আনুন ও নোট যোগ করুন",
    liveVideos: "গেমপ্লে ভিডিও",
    more: "আরও",
    viewAll: "সব দেখুন",
    viewAllCount: "সব {n}টি দেখুন",
    intro: "এই গেম সম্পর্কে",
    screenshots: "স্ক্রিনশট",
    controlMethod: "কন্ট্রোল: ",
    playerReviews: "রিভিউ",
    commentCount: "{n}",
    recommend: "সুপারিশ",
    notRecommend: "সুপারিশ নয়",
    similarGames: "একই ধরনের গেম",
    collect: "ফেভারিট",
    collected: "ফেভারিট করা",
    collectStar: "☆ ফেভারিট",
    collectedStar: "★ ফেভারিট করা",
    unfavorited: "ফেভারিট থেকে সরানো হয়েছে",
    entering: "ঢুকছে…",
    unlockSvip: "SVIP দিয়ে আনলক করুন",
    unlockVip: "VIP দিয়ে আনলক করুন",
    startGame: "খেলুন",
    reviewCount: "{n}টি রিভিউ",
    sortHot: "জনপ্রিয়",
    sortNew: "নতুন",
    noMore: "আর নেই",
    playedHours: "{n} ঘণ্টা খেলা হয়েছে",
    report: "রিপোর্ট",
    reportTitle: "এই কমেন্টটি রিপোর্ট করবেন?",
    reportMessage: "আমাদের মডারেটররা এটি দেখবেন। রিপোর্ট করবেন?",
    reported: "রিপোর্ট করা হয়েছে",
    noReviews: "এখনও কোনো রিভিউ নেই — প্রথম হোন",
    writeReview: "রিভিউ লিখুন",
    reviewPlaceholder: "আপনার অভিজ্ঞতা শেয়ার করুন… (অন্তত ৫ অক্ষর)",
    reviewMinLength: "রিভিউ অন্তত ৫ অক্ষরের হতে হবে",
    reviewSubmitted: "রিভিউ জমা হয়েছে",
    publish: "পোস্ট করুন",
    commentDetail: "কমেন্ট",
    replyCount: "{n}টি রিপ্লাই",
    noReplies: "এখনও কোনো রিপ্লাই নেই — প্রথম হোন",
    reply: "রিপ্লাই",
    replyToUser: "{'@'}{name}-কে রিপ্লাই",
    saySomething: "কিছু লিখুন…",
    send: "পাঠান",
    sent: "পাঠানো হয়েছে",
    videoCount: "{n}টি ভিডিও",
    watchCount: "{k}k ভিউ",
    noVideos: "এখনও কোনো ভিডিও নেই",
    videoUnavailable: "এই ভিডিওটি এখন চালানো যাচ্ছে না",
    videoUnavailableDesc: "হয়তো পুরোনো ক্লিপ যা সরিয়ে নেওয়া হয়েছে — অন্যটি দেখুন",
  },
  search: {
    placeholder: "গেমের নাম লিখুন",
    emptyHint: "গেমের নাম বা পিনইন দিয়ে সার্চ করুন",
    history: "সাম্প্রতিক সার্চ",
    clear: "মুছুন",
    noResults: "কোনো গেম পাওয়া যায়নি",
  },
  misc: {
    savesTitle: "গেম সেভ",
    savesTitleNamed: "{name} - সেভ",
    savesLoginPrompt: "আপনার গেম সেভ দেখতে লগইন করুন",
    savesActiveHeading: "সক্রিয় সেভ",
    savesUnnamed: "নামহীন সেভ",
    savesEditRemark: "নাম বদলান",
    savesEmpty: "এখনও কোনো ক্লাউড সেভ নেই",
    savesEmptyHint: "গেমের ভিতরে করা সেভ এখানে নিজে থেকেই সিঙ্ক হয়",
    savesHistory: "ইতিহাস",
    savesCount: "{n}টি সেভ",
    savesCurrent: "বর্তমান",
    savesCorrupted: "নষ্ট",
    savesRestore: "ফিরিয়ে আনুন",
    savesNoHistory: "কোনো সেভ ইতিহাস নেই",
    savesFooter:
      "গেমের ভিতরে ম্যানুয়াল / অটো সেভে সেভ তৈরি হয় এবং নিজে থেকেই ক্লাউডে সিঙ্ক হয়। আপাতত ম্যানুয়ালি মোছা যায় না (গেমে সেভ চালিয়ে গেলে সবচেয়ে পুরোনোটি ওভাররাইট হয়)।",
    savesRemarkTitle: "সেভের নাম এডিট করুন",
    savesRemarkPlaceholder: "এই সেভের একটি নাম দিন, যেমন \"অধ্যায় ১ শেষ\"",
    savesSave: "সেভ",
    savesAlreadyCurrent: "এটিই বর্তমান সেভ",
    savesRestoreTitle: "সেভ ফিরিয়ে আনুন",
    savesRestoreConfirm:
      "এই সেভে ফিরবেন? পরেরবার চালু করলে গেম \"{name}\" থেকে শুরু হবে।",
    savesSwitched: "এই সেভে স্যুইচ হয়েছে",
    savesSaved: "সেভ হয়েছে",
    ctrlNavTitle: "কন্ট্রোলার সেটিংস",
    ctrlSave: "সেভ",
    ctrlIntro:
      "এখানে মাউস / গেমপ্যাডের ফিল ঠিক করুন। কোনো মান খালি / 0 রাখলে প্রতিটি গেমের সার্ভার ডিফল্ট মানা হয়; পরিবর্তন সব গেমে প্রযোজ্য।",
    ctrlMouseSensitivity: "মাউস সংবেদনশীলতা",
    ctrlServerDefault: "সার্ভার ডিফল্ট",
    ctrlMouseHint: "লকড মোডে চলাচলের দূরত্ব = আসল নড়াচড়া × {n}%",
    ctrlStickSensitivity: "ডান স্টিক সংবেদনশীলতা",
    ctrlStickHint:
      "FPS / অ্যাকশন গেমে এইম ঘোরানোর গতি। বাম স্টিকে (চলাচল) প্রভাব পড়ে না।",
    ctrlPrimaryClick: "প্রাইমারি মাউস বাটন",
    ctrlLeftPrimary: "বাম প্রাইমারি",
    ctrlRightPrimary: "ডান প্রাইমারি",
    ctrlPrimaryClickHint:
      "কিছু গেম (যেমন কিছু ইন্ডি গেম) ডিফল্টে ডান-ক্লিকে ফায়ার করে, অদলবদল লাগে।",
    ctrlResetDefault: "রিসেট",
    ctrlSavedToast: "সেভ হয়েছে, পরেরবার চালু করলে কার্যকর হবে",
    ctrlResetToast: "সার্ভার কনফিগে ফিরে গেছে",
    savesUploading: "সেভ আপলোড হচ্ছে — একটু পরে আবার চেষ্টা করুন",
    savesCheckFailed: "সেভ স্ট্যাটাস যাচাই ব্যর্থ — আবার চেষ্টা করুন",
  },
  play: {
    stageReady: "প্রস্তুত",
    queueing: "কিউতে",
    queueJoining: "কিউতে যোগ দেওয়া হচ্ছে…",
    queueAheadPrefix: "",
    queueAheadSuffix: "জন আপনার আগে আছেন",
    queueEta: "প্রায় {n}s",
    cancelReturn: "বাতিল করে ফিরুন",
    back: "ফিরুন",
    retry: "আবার চেষ্টা",
    goSubscribe: "আপগ্রেড",
    entering: "গেমে ঢোকা হচ্ছে",
    vipCta: "এখনই ঢুকতে VIP-তে আপগ্রেড করুন",
    vipPerks: "কিউ নেই + এইচডি মান + দীর্ঘ সেশন",
    sessionExpiredHint:
      "দীর্ঘ অপেক্ষার পর সাধারণত সেশন শেষ হয়ে যায় — আবার কিউ করতে \"আবার চেষ্টা\" চাপুন",
    lineOldUser: "পুরোনো প্লেয়ার কিউ",
    lineNewbie: "নতুন প্লেয়ার কিউ",
    lineFast: "ফাস্ট-ট্র্যাক কিউ",
    lineSvip: "SVIP কিউ",
    svipRequired: "এই গেমটি শুধু SVIP-এর জন্য। আগে SVIP-তে আপগ্রেড করুন",
    stageConnectingServer: "সার্ভারে সংযোগ হচ্ছে…",
    stageHandshake: "সার্ভারের সাথে হ্যান্ডশেক হচ্ছে…",
    stageP2pNegotiating: "P2P চ্যানেল ঠিক করা হচ্ছে…",
    stageMediaStreaming: "মিডিয়া স্ট্রিম হচ্ছে…",
    stageWaitingFrame: "ভিডিওর জন্য অপেক্ষা…",
    stageVideoTrack: "ভিডিও ট্র্যাক পাওয়া গেছে…",
    stageEntered: "সংযুক্ত",
    stageConnect: "সংযোগ",
    stageConnectedSoon: "সংযুক্ত — ভিডিও শীঘ্রই আসছে…",
    allocFailed: "গেম সার্ভার বরাদ্দ করা যায়নি",
    allocFailedHttp: "বরাদ্দ ব্যর্থ (HTTP {status})",
    reenterHint: " (গেম থেকে বের হয়ে আবার ঢুকুন)",
    errP2pFailed: "P2P সংযোগ ব্যর্থ। আপনার নেটওয়ার্ক দেখে নিন",
    errDisconnected: "সংযোগ বিচ্ছিন্ন (code={code})। আবার চেষ্টা করুন",
    errStageFailed: "{stage} ব্যর্থ হয়েছে",
    errStageFailedDetail: "{stage} ব্যর্থ হয়েছে: {detail}",
    errConnectTimeout:
      "সংযোগ টাইম-আউট — সার্ভারে পৌঁছানো যায়নি। নেটওয়ার্ক দেখে আবার চেষ্টা করুন",
    errQueueCancelled: "সার্ভার আপনার কিউ বাতিল করেছে। আবার চেষ্টা করুন",
    errKicked:
      "আপনার অ্যাকাউন্ট অন্য ডিভাইসে লগইন হয়েছে, তাই এই সেশন বিচ্ছিন্ন হয়েছে",
    errCannotStart: "এখন গেম শুরু করা যাচ্ছে না",
    registerFailed: "রেজিস্ট্রেশন ব্যর্থ",
  },
  game: {
    recharge: "রিচার্জ",
    tabControl: "কন্ট্রোল",
    tabFrame: "ডিসপ্লে",
    tabVoice: "সাউন্ড",
    controlScheme: "কন্ট্রোল মোড",
    hideVirtualKeys: "ভার্চুয়াল কী লুকান",
    mouseMode: "মাউস মোড",
    mouseModeTouchpad: "টাচপ্যাড",
    mouseModeDrag: "ড্র্যাগ",
    mouseModeDirect: "সরাসরি",
    mouseSensitivity: "মাউস সংবেদনশীলতা {n}%",
    rightStickMode: "ডান স্টিক মোড",
    joyModeFixed: "স্থির",
    joyModeHalf: "অর্ধ পর্দা",
    joyModeFull: "পূর্ণ পর্দা",
    joyModeDrag: "ড্র্যাগ",
    stickSensitivity: "স্টিক সংবেদনশীলতা {n}%",
    customLayout: "কাস্টম কী লেআউট",
    editLayout: "লেআউট এডিট করুন",
    frameComingSoon:
      "ডিসপ্লে স্কেলিং / মান পরিবর্তন পরের সংস্করণে আসছে।",
    gameSound: "গেম সাউন্ড",
    schemeFollow: "গেম অনুসরণ",
    schemeGamepad: "গেমপ্যাড",
    schemeKeyMouse: "কীবোর্ড ও মাউস",
    schemeTouch: "টাচ",
    schemeSwitchedGamepad: "গেমপ্যাডে স্যুইচ হয়েছে",
    schemeSwitchedKeyMouse: "কীবোর্ড ও মাউসে স্যুইচ হয়েছে",
    schemeSwitchedFollow: "গেম অনুসরণে ফিরেছে",
    modifierTitle: "মডিফায়ার",
    modifierNeedUnlock: "এই মডিফায়ারটি আনলক করতে কিনতে হবে",
    usageTitle: "নির্দেশনা",
    usageEmpty: "এখনও কোনো নির্দেশনা নেই",
    gotIt: "বুঝেছি",
    close: "বন্ধ",
    noModifiers: "কোনো মডিফায়ার নেই",
    locked: "লকড",
    needUnlock: "আনলক করতে কিনুন",
    remaining: "{d} বাকি",
    use: "ব্যবহার",
    quitTitle: "গেম থেকে বের হোন",
    quitConfirm: "এই গেম থেকে বের হবেন?",
    quitConfirmBtn: "বের হোন",
    quitCancelBtn: "খেলা চালিয়ে যান",
    joyNameFixed: "স্থির",
    joyNameHalfZone: "অর্ধ-পর্দা জোন",
    joyNameFullFollow: "পূর্ণ-পর্দা অনুসরণ",
    joyNameDrag: "ড্র্যাগ",
    padConnected: "🎮 গেমপ্যাড সংযুক্ত, ভার্চুয়াল কী লুকানো হয়েছে",
    padDisconnected: "গেমপ্যাড বিচ্ছিন্ন, ভার্চুয়াল কী ফিরে এসেছে",
    rightStickToast: "ডান স্টিক: {name}",
    noEditableLayout: "এডিট করার মতো কোনো কী লেআউট নেই",
    timeUsedUp: "খেলার সময় শেষ",
    addTimeSuccess: "সময় যোগ হয়েছে",
    submitted: "জমা হয়েছে",
    minutesShort: "{n} মিনিট",
    addTime: "সময় যোগ করুন",
    expand: "বিস্তার",
    collapse: "সংকুচিত",
    physicalPadConnected: "ফিজিক্যাল গেমপ্যাড সংযুক্ত",
    unmute: "আনমিউট",
    mute: "মিউট",
    fullscreen: "পূর্ণ পর্দা",
    summonKeyboard: "কীবোর্ড দেখান",
    sensoryMode: "মোশন কন্ট্রোল",
    idleWarnTip: "কোনো কার্যকলাপ নেই। {n}s এর মধ্যে গেম থেকে বেরিয়ে যাবে।",
    idleContinue: "চালিয়ে যান",
    nsInputTitle: "গেমে টেক্সট ইনপুট দরকার",
    nsInputHint: "টেক্সট লিখে নিশ্চিত করুন",
    settings: "সেটিংস",
    currentRemaining: "{n} মিনিট বাকি",
    exchangeBeans: "বিন দিয়ে সময় নিন",
    useAddTimeCard: "টাইম কার্ড ব্যবহার করুন",
  },
  net: {
    requestFailed: "অনুরোধ ব্যর্থ",
    errorWithCode: "ত্রুটি {code}",
    serverError: "সার্ভার ত্রুটি {status}",
    timeout: "অনুরোধের সময় শেষ",
    networkError: "নেটওয়ার্ক ত্রুটি",
  },
  controls: {
    selectKeyFirst: "আগে একটি বাটন বেছে নিন",
    saved: "সেভ হয়েছে",
    saveFailed: "সেভ ব্যর্থ হয়েছে",
    selected: "নির্বাচিত: {name}",
    keyFallback: "বাটন",
    hint: "সরাতে টেনে আনুন; আকার / স্বচ্ছতা / অ্যাকশন বদলাতে ট্যাপ করুন",
    size: "আকার {pct}%",
    opacity: "স্বচ্ছতা {pct}%",
    operation: "অ্যাকশন",
    opPress: "চাপুন",
    opDrag: "ড্র্যাগ",
    opLock: "লক",
    delete: "মুছুন",
    addKey: "বাটন যোগ করুন",
    reset: "রিসেট",
    save: "সেভ",
    addHiddenKey: "একটি লুকানো বাটন যোগ করুন",
    noHiddenKeys: "কোনো লুকানো বাটন নেই",
  },
};

export default messages;
